import React, { useState } from 'react';
import UpgradeButtons from '../pages/settings/UpgradeButtons';

const SESSION_KEY = 'trial-expired-dismissed';

const TrialExpiredOverlay: React.FC = () => {
    const [dismissed, setDismissed] = useState(
        () => sessionStorage.getItem(SESSION_KEY) === 'true'
    );

    const handleTalkToSupport = () => {
        const adminPhone = import.meta.env.VITE_ADMIN_WHATSAPP_PHONE || '1829XXXXXXX';
        const msg = encodeURIComponent('Hola, tengo una pregunta sobre activar un plan para mi clínica.');
        window.open(`https://wa.me/${adminPhone}?text=${msg}`, '_blank');
    };

    const handleDismiss = () => {
        sessionStorage.setItem(SESSION_KEY, 'true');
        setDismissed(true);
    };

    if (dismissed) return null;

    return (
        <div className="fixed inset-0 z-[999] flex items-end sm:items-center justify-center p-0 sm:p-4">
            {/* Backdrop — semi-transparent, blurred */}
            <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" />

            {/* Panel */}
            <div className="relative w-full sm:max-w-md rounded-t-3xl sm:rounded-3xl overflow-hidden shadow-2xl"
                style={{ background: 'linear-gradient(160deg, #0f172a 0%, #1e1b4b 100%)', border: '1px solid rgba(255,255,255,0.08)' }}>

                {/* Top accent */}
                <div className="h-1 w-full" style={{ background: 'linear-gradient(90deg, #6366f1, #a855f7)' }} />

                {/* Mobile handle */}
                <div className="flex justify-center pt-3 sm:hidden">
                    <div className="w-10 h-1 rounded-full bg-white/20" />
                </div>

                <div className="px-6 pt-5 pb-6 flex flex-col gap-5">

                    {/* Header */}
                    <div className="flex items-start gap-4">
                        <div className="w-12 h-12 rounded-2xl flex items-center justify-center flex-shrink-0"
                            style={{ background: 'rgba(245,158,11,0.15)', border: '1px solid rgba(245,158,11,0.3)' }}>
                            <span className="material-symbols-outlined text-amber-400 text-[24px]">timer_off</span>
                        </div>
                        <div>
                            <p className="font-black text-white text-lg leading-tight">Tu prueba gratuita terminó</p>
                            <p className="text-slate-400 text-sm mt-1 leading-relaxed">
                                Diana sigue respondiendo y agendando. El seguimiento automático, reactivación y demás funciones Pro están pausadas hasta que actives un plan.
                            </p>
                        </div>
                    </div>

                    {/* What still works */}
                    <div className="rounded-xl p-3 flex flex-col gap-2"
                        style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}>
                        <p className="text-xs font-bold text-slate-300 uppercase tracking-wide mb-1">Sigue activo</p>
                        {['Respuestas automáticas 24/7', 'Agendamiento de citas', 'Historial de conversaciones'].map(f => (
                            <div key={f} className="flex items-center gap-2">
                                <span className="material-symbols-outlined text-brand-accent text-[16px]">check_circle</span>
                                <span className="text-sm text-slate-300">{f}</span>
                            </div>
                        ))}
                        <div className="border-t border-white/5 mt-1 pt-2">
                            {['Seguimiento proactivo', 'Reactivación automática', 'Reportes de impacto'].map(f => (
                                <div key={f} className="flex items-center gap-2 mt-1.5">
                                    <span className="material-symbols-outlined text-slate-600 text-[16px]">lock</span>
                                    <span className="text-sm text-slate-500 line-through">{f}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Upgrade buttons — checkout de PayPal real, no requiere esperar a un admin */}
                    <UpgradeButtons />

                    {/* Fallback humano, para dudas puntuales — no es el camino principal */}
                    <button
                        onClick={handleTalkToSupport}
                        className="text-center text-xs text-slate-500 hover:text-slate-300 transition-colors py-1"
                    >
                        ¿Tienes dudas? Escríbenos por WhatsApp
                    </button>

                    {/* Dismiss */}
                    <button
                        onClick={handleDismiss}
                        className="text-center text-xs text-slate-600 hover:text-slate-400 transition-colors py-1"
                    >
                        Continuar al panel sin activar →
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TrialExpiredOverlay;
